<template>
  <t-modal
    :visibled.sync="showModal"
    :closable="true"
    :mask-closable="maskClosable"
    :before-ok="$_beforeOk"
    width="850"
    ok-text="保存"
    cancel-text="取消"
    :ok="$_ok"
    :cancel="$_updateValue"
  >
    <div slot="header">
      <span class="font-weight-bold float-left text-dark">{{ title }}</span>
      <small class="text-muted ml-8 text-sm">{{ subtitle }}</small>
    </div>
    <div :class="prefix+'-head'">
      <div :class="prefix+'-head__header'">
        <t-button type="primary" class="mr-8" @click="chooseImage">{{ chooseImageBtnText }}</t-button>
        <input v-if="showModal" v-show="false" ref="fileInput" type="file" @change="handleChange">
        <span v-if="imageFlie.img">
          <t-icon type="file" size="16" class="mr-base"></t-icon>
          <a class="text-dark" style="line-height: 24px;">{{ imageFlie.name }}</a>
        </span>
      </div>
      <div :class="prefix+'-head__body'">
        <div :class="prefix+'-head__fixed-area'">
          <cropper
            ref="cropper"
            :img="imageFlie.img"
            :can-move="false"
            :center-box="true"
            :auto-crop="true"
            :auto-crop-width="cropWidth"
            :auto-crop-height="cropHeight"
            :fixed="fixed"
            :fixed-number="fixedNumber"
            :output-size="outputSize"
            :output-type="outputType"
            @cropMoving="$_updataImage"
            @realTime="$_updataImage"
          ></cropper>
        </div>
        <div :class="prefix+'-head__preview-area'">
          <p class="text-dark">{{ desc }}</p>
          <ul :class="prefix+'-head__size-list'">
            <li :class="prefix+'-head__size-item'">
              <div :style="imageStyle" :class="prefix+'-head__priview-img'">
                <img v-if="imageFlie.base64" :src="imageFlie.base64">
              </div>
              <span class="d-block text-dark text-center">{{ imageText }}</span>
            </li>
            <li v-if="showCirleImage" :class="prefix+'-head__size-item'">
              <div :class="[prefix+'-head__priview-img', prefix+'-head__priview-img--rounded']">
                <img v-if="imageFlie.base64" :src="imageFlie.base64">
              </div>
              <span class="d-block text-dark text-center">100x100px</span>
            </li>
          </ul>
        </div>
      </div>
      <div :class="prefix+'-head__footer'">
        <t-button
          :disabled="imageFlie.base64 === ''"
          type="outline-primary"
          icon="rotate-left"
          class="mr-8"
          @click="rotateImage('left')"
        >向左旋转</t-button>
        <t-button
          :disabled="imageFlie.base64 === ''"
          type="outline-primary"
          icon="rotate-right"
          @click="rotateImage('right')"
        >向右旋转</t-button>
      </div>
    </div>
  </t-modal>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
import Cropper from './cropper.vue'

export default {
  name: 'TUploadHead',
  components: {
    Cropper
  },
  props: {
    // props data
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '上传头像'
    },
    subtitle: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: '您上传的头像会自动生成小尺寸头像，请注意小尺寸的头像是否清晰'
    },
    chooseImageBtnText: {
      type: String,
      default: '请选择图片'
    },
    maxSize: {
      type: Number,
      default: 1024
    },
    showCirleImage: {
      type: Boolean,
      default: true
    },
    cropWidth: {
      type: Number,
      default: 150
    },
    cropHeight: {
      type: Number,
      default: 150
    },
    fixed: {
      type: Boolean,
      default: true
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [1, 1]
      }
    },
    outputSize: {
      type: Number,
      default: 1,
      validator: function(value) {
        return [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1].includes(value)
      }
    },
    outputType: {
      type: String,
      default: 'jpeg',
      validator: function(value) {
        return ['jpeg', 'png', 'webp'].includes(value)
      }
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    // store data
    return {
      prefix: PREFIX_CLASS + 'upload',
      showModal: false,
      imageFlie: {
        name: '',
        type: '',
        size: '',
        img: '',
        base64: ''
      }
    }
  },
  computed: {
    imageStyle() {
      let vm = this
      let width = vm.cropWidth
      let height = vm.cropHeight
      if (width !== height) {
        return `width: ${width}px;height: ${height}px`
      } else {
        return ''
      }
    },
    imageText() {
      // eslint-disable-next-line one-var
      let text = '100x100px',
        vm = this,
        width = vm.cropWidth,
        height = vm.cropHeight
      if (width !== height) {
        text = `${width}x${height}px`
      }
      return text
    }
  },
  watch: {
    value(val) {
      this.showModal = val
      this.$emit('input', val)
    }
  },
  methods: {
    // 更新父级 v-model 值
    $_updateValue() {
      this.$emit('input', this.showModal)
      // 清除数据
      this.$_clear()
    },
    // 清除所有数据
    $_clear() {
      this.imageFlie = {
        name: '',
        type: '',
        size: '',
        img: '',
        base64: ''
      }
      this.$refs.cropper.refresh()
    },
    // 选择图片
    chooseImage() {
      this.$refs.fileInput.click()
    },
    // 修改图片事件
    handleChange(e) {
      e.preventDefault()
      let files = e.target.files || e.dataTransfer.files
      if (this.$_uploadFile(files[0])) {
        this.setSourceImg(files[0])
      }
    },
    //
    $_uploadFile(file) {
      if (!this.beforeUpload) {
        return this.checkFile(file)
      }
      let before = this.beforeUpload(file)
      if (before && before.then) {
        before.then(processedFile => {
          if (
            Object.prototype.toString.call(processedFile) === '[object File]'
          ) {
            this.checkFile(processedFile)
          } else {
            this.checkFile(file)
          }
          return true
        }).catch(() => {
          return new Error('Upload failure')
        })
      } else if (before !== false) {
        return this.checkFile(file)
      } else {
        return false
      }
    },
    // 检测选择的文件是否合适
    checkFile(file) {
      // eslint-disable-next-line one-var
      let vm = this,
        { maxSize } = vm
      // 仅限图片
      if (!file.type || file.type.indexOf('image') === -1) {
        vm.$Message.danger('仅支持上传图片！')
        return false
      }
      // 超出大小
      if (file.size / 1024 > maxSize) {
        vm.$Message.danger(`图片文件最大为${maxSize}kb！`)
        return false
      }
      return true
    },
    // 设置图片源
    setSourceImg(file) {
      // eslint-disable-next-line one-var
      let vm = this,
        fr = new FileReader()
      fr.onload = function(e) {
        vm.imageFlie.img = fr.result
        vm.imageFlie.name = file.name
        vm.imageFlie.type = file.type
        vm.imageFlie.size = file.size
        vm.$refs.cropper.startCrop()
      }
      fr.readAsDataURL(file)
    },
    // 更新图片
    $_updataImage() {
      let vm = this
      vm.$refs.cropper.getCropData(data => {
        vm.imageFlie.base64 = data
      })
    },
    // 旋转图片
    rotateImage(position) {
      this.$refs.cropper[`rotate${position === 'left' ? 'Left' : 'Right'}`]()
    },
    // 点击确认按钮执行确认逻辑前
    $_beforeOk() {
      // 未上传图片禁止点击确认按钮
      if (!this.imageFlie.name) {
        this.$Message.danger('请上传图片文件！')
        return false
      }
    },
    // 点击确认按钮
    $_ok() {
      let vm = this
      // 获取裁切图片信息
      vm.$refs.cropper.getCropData(data => {
        vm.$refs.cropper.getCropBlob(blobData => {
          // 返回图片数据
          vm.$emit('on-ok', {
            name: vm.imageFlie.name,
            type: vm.imageFlie.type,
            size: vm.imageFlie.size,
            blobSize: blobData.size,
            blobType: blobData.type,
            base64: data
          })
        })
      })
      this.showModal = false
      // 更新 v-model 值
      vm.$_updateValue()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/upload-head/upload-head.vue